import React from "react";
import { type FieldValues, useForm } from "react-hook-form";
import Button from "../../components/shared/button";
import Checkbox, {
  CheckboxType,
} from "../../components/shared/inputs/checkbox";
import Radio, { RadioType } from "../../components/shared/inputs/radio";
import OptionBar from "../../components/shared/optionBar";
import { Tooltip } from "antd";

const CheckboxAndSwitchers: React.FC = () => {
  const { handleSubmit, reset, control } = useForm<FieldValues>({
    defaultValues: {
      4: true,
      7: true,
      6: true,
      8: "Option3",
      checkox_option_9: true,
      checkox_option_7: true,
      checkox_option_6: true,
      RadioDemo4: "yes",

      RadioDemo2: "table_View",
      RadioDemo6: "leaf",
    },
  });
  return (
    <view>
      <view data-vertical="" data-adaptive="">
        <view data-scroll="">
          <group data-direction="column" data-gap="15" data-space="30">
            <text
              data-weight="700"
              data-text-size="xxx-large"
              data-wrap="wrap"
              data-color="main"
            >
              Checkbox & Radio
            </text>
            <text
              data-wrap="wrap"
              data-length="300"
              data-line="1.5"
              data-light=""
            >
              Checkboxes let users select one or more items from a list, or turn
              an item on or off
            </text>
          </group>
          <group data-space="30">
            <group
              data-type="grid"
              data-grid-template="200"
              data-gap="1"
              data-contain=""
            >
              <group
                data-gap="1"
                data-background="main-background"
                data-direction="column"
                data-contain=""
                data-border=""
              >
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Checkbox
                    name="1"
                    label="Classic Checkbox"
                    checkbox
                    control={control}
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  <Tooltip arrow={false} title="No Label">
                    {" "}
                    <Checkbox name="4" control={control} />
                  </Tooltip>
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Checkbox
                    name="2"
                    label="Disabled Classic Checkbox "
                    classic
                    control={control}
                    disabled
                  />
                </group>
              </group>

              <group
                data-gap="1"
                data-direction="column"
                data-background="main-background"
                data-contain=""
                data-border=""
              >
                <group data-width="auto" data-border="" data-space="20">
                  <Checkbox
                    name="3"
                    simple
                    label="Toggle Switch"
                    control={control}
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  <Checkbox name="11" simple control={control} />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  <Checkbox
                    name="5"
                    label="Disabled Toggle Switch"
                    disabled
                    simple
                    control={control}
                  />
                </group>
              </group>

              <group data-gap="1" data-contain="" data-direction="column">
                <group data-width="auto" data-border="" data-space="20">

                  <Checkbox
                    name="6"
                    minimal
                    label="Minimal Checkbox"
                    control={control}
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">

                  <Checkbox name="9" minimal control={control} />{" "}
                </group>

                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Checkbox
                    name="7"
                    minimal
                    label="Disabled Checkbox 7"
                    disabled
                    control={control}
                  />{" "}
                </group>
                {/* <group data-width="auto" data-border="" data-space="20">            <label
            simple="" //NOSONAR
            checkbox="" //NOSONAR
          >
            <name>
              <b>Section Title</b>
            </name>
            <separator data-vertical=""></separator> <input type="checkbox" />
            <tip></tip>
          </label> </group> */}
              </group>

              <group
                data-gap="1"
                data-contain=""
                data-direction="column"
                data-border=""
              >
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Radio
                    name="8"
                    radioValue="Option1"
                    label="Radio Button"
                    control={control}
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Radio
                    name="8"
                    radioValue="Option2"
                    label="Radio Button"
                    control={control}
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Radio
                    name="8"
                    radioValue="Option3"
                    label="Radio Button disabled"
                    control={control}
                    disabled
                  />
                </group>
                <group data-width="auto" data-border="" data-space="20">
                  {" "}
                  <Radio
                    name="8"
                    radioValue="Option4"
                    allowUncheck
                    label="Radio Button allowed uncheck"
                    control={control}
                  />
                </group>
              </group>
            </group>

            <group data-border="" data-space="20">
              <label radio="" data-custom="" className="" aria-describedby="«r5t»" data-lenght="autofit" data-fit="1">
                <input placeholder=" " radio="" type="radio" checked value="Option1" name="8" />
                <box><check></check><ink></ink></box>
                <text className="">Radio Checkboxes let users select one or more items from a list, or turn an item on or off</text>
                <separator data-horizontal=""></separator>
              </label>
              <label radio="" data-custom="" className="" aria-describedby="«r5t»" data-lenght="autofit" data-fit="1">
                <input placeholder=" " radio="" type="radio" checked value="Option1" name="9" />
                <box><check></check><ink></ink></box>
                <text className="">Radio Button</text>
                <separator data-horizontal=""></separator>
              </label>
              <label radio="" data-custom="" className="" aria-describedby="«r5t»" data-lenght="autofit" data-fit="1">
                <input placeholder=" " radio="" type="radio" checked value="Option1" name="10" />
                <box><check></check><ink></ink></box>
                <text className="">Radio Button</text>
                <separator data-horizontal=""></separator>
              </label>
              <label radio="" data-custom="" className="" aria-describedby="«r5t»" data-lenght="autofit" data-fit="1">
                <input placeholder=" " radio="" type="radio"  value="Option1" name="11" />
                <box><check></check><ink></ink></box>
                <text className="">Radio Button</text>
                <separator data-horizontal=""></separator>
              </label>
            </group>
          </group>
        </view>
        <view data-scroll="">
          <group data-direction="column" data-gap="15" data-space="30">
            <text
              data-weight="700"
              data-text-size="xxx-large"
              data-wrap="wrap"
              data-color="main"
            >
              Switch
            </text>
            <text
              data-wrap="wrap"
              data-length="300"
              data-line="1.5"
              data-light=""
            >
              Switches toggle the selection of an item on or off
            </text>
          </group>

          <group data-space="30">
            <group data-contain="">
              <group
                data-gap="10"
                data-space-vertical="20"
                data-border=""
                data-background="main-background"
              >
                <OptionBar autosize>
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo1"
                    radioValue="Dashboard"
                    label="Dashboard"
                  />
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo1"
                    radioValue="Listview"
                    //    icon="table_rows"
                    label="List View"
                  />
                </OptionBar>
              </group>
              <group
                data-gap="10"
                data-space-vertical="20"
                data-border=""
                data-background="main-background"
              >
                <OptionBar compact dynamic data-palette="secondary">
                  <group>
                    <Radio
                      control={control}
                      radioType={RadioType.Button}
                      allowUncheck
                      name="RadioDemo2"
                      radioValue="Thumbnail_View"
                      icon="grid_view"
                      tooltip="Thumbnail View"
                    />
                    <Radio
                      control={control}
                      radioType={RadioType.Button}
                      name="RadioDemo2"
                      radioValue="Column_View"
                      icon="view_stream"
                      tooltip="Column View"
                    />
                    <Radio
                      control={control}
                      radioType={RadioType.Button}
                      name="RadioDemo2"
                      radioValue="table_View"
                      icon="table_rows"
                      tooltip="Table View"
                      label="Table View"
                    />
                  </group>
                </OptionBar>
                <separator data-vertical=""></separator>
                <OptionBar compact dynamic data-palette="lighter">
                  <group>
                    <Radio
                      control={control}

                      radioType={RadioType.Button}
                      allowUncheck
                      name="RadioDemo6"
                      radioValue="leaf"
                      label="Leaf"
                      icon="nest_eco_leaf"
                      tooltip="Leaf"
                    />
                    <Radio
                      control={control}
                      radioType={RadioType.Button}
                      name="RadioDemo6"
                      radioValue="Sample_View"
                      label="Sample Label"
                      tooltip="Column View"
                    />
                    <Radio
                      control={control}
                      radioType={RadioType.Button}
                      name="RadioDemo6"
                      radioValue="Table View"
                      icon="home"
                      tooltip="Home"
                    />
                  </group>
                </OptionBar>
              </group>
              <group
                data-gap="10"
                data-space-vertical="20"
                data-border=""
                data-background="main-background"
              >
                <OptionBar compact dynamic>
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo3"
                    radioValue="Grid View"
                    icon="grid_view"
                    label="Grid View"
                  />
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo3"
                    radioValue="List View"
                    icon="table_rows"
                    label="List View"
                  />
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo3"
                    radioValue="Dashboard"
                    icon="view_stream"
                    label="Dashboard"
                  />
                </OptionBar>
                <OptionBar compact>
                  <group>
                    <label
                      effect="material" //NOSONAR
                    >
                      <input type="radio" name="demo_2" value="" />
                      <wrap>
                        <icon>table_rows</icon>
                      </wrap>
                    </label>
                    <label
                      effect="material" //NOSONAR
                    >
                      <wrap
                        gap="none" //NOSONAR
                      >
                        <icon data-space="5">expand_more</icon>
                      </wrap>
                    </label>
                  </group>
                </OptionBar>

                <text data-space="10"> Animated Switcher </text>
                <separator data-vertical=""></separator>

                <OptionBar fixed animate>
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo4"
                    radioValue="yes"
                    label="Yes"
                  />
                  <Radio
                    control={control}
                    radioType={RadioType.Button}
                    name="RadioDemo4"
                    radioValue="no"
                    label="No"
                  />
                </OptionBar>
              </group>
              <group
                data-gap="10"
                data-space-vertical="20"
                data-border=""
                data-background="main-background"
              >
                <OptionBar data-length="400" data-height="40">
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_1"
                    label="Mon"
                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_2"
                    label="Tue"
                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_3"
                    label="Wed"

                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_4"
                    label="Thu"
                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_5"
                    label="Fri"
                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_6"
                    label="Sat"
                  />
                  <Checkbox
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_7"
                    label="Sun"
                  />
                </OptionBar>
              </group>

              <group
                data-gap="10"
                data-space-vertical="20"
                data-border=""
                data-background="main-background"
              >
                <OptionBar
                  data-length="300"
                  data-height="50"
                // data-palette="lighter"
                >
                  <Checkbox
                    icon="chair"
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_9"
                    label="Chair"
                  />
                  <Checkbox
                    icon="laundry"
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_10"
                    label="Shirt"
                  />
                  <Checkbox
                    icon="pet_supplies"
                    control={control}
                    checkboxType={CheckboxType.Button}
                    name="checkox_option_11"
                    label="Pet"
                  />
                </OptionBar>
              </group>
            </group>
          </group>
        </view>
      </view>

      <group data-space="20">
        <group data-type="grid" data-gap="10">
          <Button
            primary
            large
            text="Submit"
            onClick={handleSubmit((data: any) => console.log(data))}
          />
          <Button outline large text="Reset" onClick={() => reset()} />
        </group>
      </group>
    </view>
  );
};
export default CheckboxAndSwitchers;
